import React, { useState } from "react";
import clsx from "clsx";
import { Controller, useForm } from "react-hook-form";
import {
  Switch,
  FormControlLabel,
  Typography,
} from "@material-ui/core";

import { useStyles } from "../styles";

import { useEnqueueSnackbar } from "../../../../hooks/useEnqueueSnackbar";
import { useSettingDispatchChange } from "../index";
import { VALET_DELIVERY_METHOD } from "../../../../constants";

const ValetAreaPayLaterSettings = ({
  entityID,
  settingValues,
  onPayLaterChanged,
}) => {
  const classes = useStyles();
  const { dispatchBulkSettings } = useSettingDispatchChange();
  const enqueueSnackbar = useEnqueueSnackbar();
  const [showSettingChangeMessage, setShowSettingChangeMessage] = useState(false);

  const { control, setValue } = useForm({
    defaultValues: {
      enablepaylater: settingValues.enablePayLater ?? false,
    },
  });

  const handleBulkSettingsChange = async (
    settingArray,
    values,
    entityID,
    defaultValue,
    targetName
  ) => {
    if (!(await dispatchBulkSettings(settingArray, values, entityID))) {
      setValue(targetName, defaultValue);
      enqueueSnackbar("Unable to change Pay Later Settings", {
        variant: "error",
        tag: "PayLaterSettingChangeError",
      });
      return false;
    }
    return true;
  };

  const handleEnablePayLaterChanged = async (e) => {
    const targetValue = e.target.checked;
    const settingArray = ["valetarea.enablepaylater"];
    const values = { "valetarea.enablepaylater": targetValue };

    if (targetValue === settingValues.enablePayLater) return;

    // When enabling Pay Later, force delivery method to Manual
    const forceDeliveryToManual =
      targetValue === true &&
      settingValues.valetareadeliverymethod != VALET_DELIVERY_METHOD.MANUAL_DELIVERY;

    if (forceDeliveryToManual) {
      settingArray.push("valetarea.deliverymethod");
      values["valetarea.deliverymethod"] = VALET_DELIVERY_METHOD.MANUAL_DELIVERY;
    }

    if (
      !(await handleBulkSettingsChange(
        settingArray,
        values,
        entityID,
        settingValues.enablePayLater,
        "enablepaylater"
      ))
    ) {
      return;
    }

    onPayLaterChanged();
    setShowSettingChangeMessage(forceDeliveryToManual);
  };

  return (
    <div className={classes.payLaterContainer}>
        <Controller
          name="enablepaylater"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              role="valetarea-enablepaylater-toggle"
              label="Enable Pay Later"
              control={
                <Switch
                  {...field}
                  id="valetareaenablepaylater"
                  color="primary"
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                    handleEnablePayLaterChanged(e);
                  }}
                  checked={field.value}
                  data-checked={field.value}
                />
              }
            />
          )}
        />
        <div
          className={clsx(
            classes.payLaterMessage,
            showSettingChangeMessage
              ? classes.visibleMessage
              : classes.hiddenMessage
          )}
        >
          <Typography>
            Delivery method changed to manual delivery
          </Typography>
        </div>
    </div>
  );
};

ValetAreaPayLaterSettings.defaultProps = {
  settingValues: {},
};

export default ValetAreaPayLaterSettings;
